import styled from "styled-components";

export const Container = styled.div`

display: flex;
flex-direction: row;
align-items: center;
justify-content: center;
background-color:#EDEDED;
height: 3rem; 
width: 100%;
padding-bottom: 2rem;

.signup {    
display: flex;
flex-direction: row;
align-items: center;
justify-content: center;
background-color:#EDEDED;
height: 3rem; 
width: 100%;
padding-top: 0.6rem;

button {
    cursor: pointer;
    border: none;
    position: absolute;
    margin-left: 60vw;
}
}
.close {
    cursor: pointer;
    position: absolute;
    border: none;
    margin-right: 75vw;
    background: transparent;
}
`
export const Button = styled.div`
position: absolute;
margin-left: 70vw;
cursor: pointer;
`

export const Image = styled.img`
`
